import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL_ETL || 'http://localhost:8788';

export interface ConstructionPermit {
  id: string;
  projectId: string;
  projectName?: string;
  permitNumber: string;
  issuedBy: string;
  issuedDate: number;
  expiryDate: number;
  status: 'pending' | 'issued' | 'expired' | 'rejected' | 'in_review';
  documents: string[];
  notes?: string;
  metadata?: Record<string, any>;
}

export interface CreatePermitData {
  projectId: string;
  permitNumber: string;
  issuedBy: string;
  issuedDate: number;
  expiryDate: number;
  status?: ConstructionPermit['status'];
  documents?: string[];
  notes?: string;
}

export const permitService = {
  async getPermits(projectId: string): Promise<ConstructionPermit[]> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/finance/permits/${projectId}`
    );
    return (response.data || []).map((p: any) => ({
      id: p.id,
      projectId: p.projectId ?? p.project_id,
      permitNumber: p.permitNumber ?? p.permit_number,
      issuedBy: p.issuedBy ?? p.issued_by,
      issuedDate: p.issuedDate ?? p.issued_date,
      expiryDate: p.expiryDate ?? p.expiry_date,
      status: p.status,
      documents: Array.isArray(p.documents)
        ? p.documents
        : typeof p.documents === 'string'
        ? JSON.parse(p.documents)
        : [],
      notes: p.notes,
      metadata: p.metadata ? JSON.parse(p.metadata) : {},
    }));
  },

  async getPermitStatus(projectId: string): Promise<{
    status: string;
    hasPermit: boolean;
    details?: ConstructionPermit;
  }> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/finance/permits/${projectId}/status`
    );
    return response.data;
  },

  async createPermit(data: CreatePermitData): Promise<ConstructionPermit> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/finance/permits`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.data;
  },

  async updatePermitStatus(
    permitId: string,
    status: ConstructionPermit['status']
  ): Promise<void> {
    await authService.fetchWithAuth(`${API_URL}/api/finance/permits/${permitId}/status`, {
      method: 'PUT',
      body: JSON.stringify({ status }),
    });
  },
};